/**
 * The id AppLayout puts on its content column, and the element N8's floating recovery panel portals
 * into.
 *
 * In its own module so that both a layout and a component can import it without either one exporting
 * a non-component from a component file — which breaks Fast Refresh for that file.
 *
 * ⚠️ The panel anchors to this COLUMN rather than to the viewport, and that is deliberate: a
 * viewport-fixed panel sits on top of the sidebar, whose width is 4rem or 16rem depending on a
 * pinning preference no other part of the app can see. Anchoring to the column is correct in both
 * states with nobody having to plumb that preference around.
 */
export const FLOATING_PANEL_HOST_ID = 'app-content-column';
